import React from "react";
import { Switch } from "@mui/material";
import {
  FieldError,
  useController,
  Control,
  UseFormRegister,
} from "react-hook-form";

interface MyCheckBoxProps {
  name: string;
  control: Control<any>;
  error?: FieldError;
  disabled?: boolean;
  register?: any;
}

function MyCheckBox({
  name,
  control,
  error,
  disabled = false,
}: MyCheckBoxProps) {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    defaultValue: "No",
  });

  return (
    <Switch
      name={name}
      checked={value === "YES"}
      onChange={(e) => onChange(e.target.checked ? "YES" : "NO")}
      disabled={disabled}
    />
  );
}

export default MyCheckBox;
